<template>
    <div>
        <div class="content-header text-center">
            <div class="float-start"><button @click="deleteConversation()" class="btn btn-light"><i class="fa fa-refresh"></i> Refresh</button></div>
            <h2>Analyze Assistant</h2>
        </div>
        <div class="container-fluid min-content-height">
            <div class="row">
                <div class="col">
                    <div class="chat-scroller overflow-auto">
                        <AIMessage v-for="(msg, index) in msgItems.slice().reverse()" v-bind:message="msg.message" v-bind:name="msg.name" v-bind:timestamp="msg.timestamp" v-bind:floatSelect="msg.floatSelect" v-bind:iselps="msg.iselps" v-bind:affinity="msg.affinity" @generate-affinity="generateAffinity" :key="`component-${index}`" />
                    </div>
                    <div class="vh-15">
                        <form id="aiassist" v-on:submit.prevent="ask_question">
                            <div>
                                <label for="question" class="form-label d-none">Ask question:</label>
                                <textarea class="form-control" height="500" id="question" name="question" aria-describedby="question" v-model="form.question" v-on:keyup.enter="ask_question($event)" placeholder="Type your question"></textarea>
                            </div>
                            <button type="submit" class="btn btn-primary d-none">Submit</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import AIMessage from "./AIMessage.vue";
import axios from 'axios';
export default {
    name: 'AIAssistant',
    components: {
        AIMessage
    },
    props: {
        userData: [],
        isAdmin: {
            type: Boolean,
            default() {
                return false
            }
        },
        msgItems: [],
        hasChat: {
            type: Boolean,
            default() {
                return false
            }
        }
    },
    data(){
        return{
            form: {
                question: ''
            },
            message: '',
            name: 'AI Assistant',
            timestamp: '',
            isUser: false,
            testconv: false
        }
    },
     methods: {  
        addNewMessage(msg,name,time,float,iselps,affinity) {
            this.msgItems.push({ 'message': msg, 'name': name, 'timestamp': time, 'floatSelect': float, 'iselps': iselps, 'affinity' : affinity });
            console.log('current conversation log '+JSON.stringify(this.msgItems));
            let formData = new FormData();
            formData.append('con', JSON.stringify(this.msgItems));
            axios.post('/save_chat', formData)
            .then(
            (response) => {
                console.log('conversation saved');  
            }
            )
            .catch(
            (error) => {
                this.errorMessage = error.message;
                console.error("There was an error!", error);
                }
            );
        },
        ask_question(event) {
            const returnedValues = [];
            const returnedNames = [];
            const intialFormData = new FormData(document.getElementById("aiassist"));
            const serializedSessionId = new URLSearchParams(intialFormData).toString();
            this.addNewMessage(this.form.question,this.userData.name,this.getNow(),'flex-row-reverse',false,false);
            this.addNewMessage('','',this.getNow(),'flex-row',true,false);
            axios.get('/gpt_chat_basic',  {params: {question: this.form.question }})
            .then(
            (response) => {
                this.getNow();
                this.msgItems.splice(-1);
                var finresponse = response.data.answer.replace("\n", "<br>");
                this.addNewMessage(finresponse,'Analyze Assistant',this.getNow(),'flex-row',false,true);                
            }
            )
            .catch(
            (error) => {
                this.errorMessage = error.message;
                console.error("There was an error!", error);
                }
            );
            event.target.blur();
            this.form.question = '';
        },
        getNow() {
            const today = new Date();
            const date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
            const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
            const dateTime = date +' '+ time;
            return dateTime;
        },
        generateAffinity({answer}) {
            const returnedValues = [];
            const returnedNames = [];
            axios.get('/gpt_chat',  {params: {answer: answer }})
            .then(
                (response) => {
                    if(response.data.affinities) {
                        response.data.affinities.forEach(function(item) {
                            returnedValues.push(item[0]);
                            returnedNames.push(item[2]);
                        });
                        this.$emit('customProspectAi', {shell: 'Prospects', dataset: returnedValues, names: returnedNames });
                    }  
                }
            )
            .catch(
            (error) => {
                this.errorMessage = error.message;
                console.error("There was an error!", error);
                }
            );
            event.target.blur();
            this.form.question = '';
        },
        checkCurrent() {
            axios.get('/check_chat')
            .then(
                (response) => {
                    console.log('conversation exists, loading.... ');  
                    if(response.data.length) {
                        console.log('conversation exists, response is TRUE');
                        this.msgItems = response.data;
                    }           
                }
            )
            .catch(
                (error) => {
                    this.errorMessage = error.message;
                    // console.error("There was an error!", error);
                    console.log('conversation does not exist, response is FALSE');
                    // this.testconv =  false;
                }
            );
        },
        startConversation() {
            var initialMessage = "Hello "+this.userData.name+"! Welcome to the Analyze360 AI assistant. Begin your conversation by asking a question or telling the assistant what information you\'re looking for.<br><br><b>Examples:</b><br><i>How big is the market in Virginia for mobile pet grooming?<br>What kinds of customers buy apparel at tennis pro shops?<br>Which marketing channels work best for sports watches?<br>Develop two buyer personas for a luxury skincare product.<br>Generate a list of marketing keywords related to cruise line experiences.</i>";
            this.addNewMessage(initialMessage,'Analyze Assistant',this.getNow(),'flex-row',false,false);
            this.$emit('makeChatTrue');
        },
        deleteConversation() {
            this.msgItems.splice(0);
            this.startConversation();
        }   
    },
    mounted() {
        // console.log('test has chat? '+this.hasChat);
        //console.log('test chat? '+JSON.stringify(this.msgItems));
        //console.log('test chat length '+JSON.stringify(this.msgItems.length));
        if(!this.hasChat || this.msgItems.length == 0) {
            console.log('initial test fail, starting new conversation... ');
            //var initialMessage = "Hello "+this.userData.name+"! Welcome to the Analyze360 AI assistant. Begin your conversation by asking a question or telling the assistant what information you\'re looking for.<br><br><b>Examples:</b><br><i>How big is the market in Virginia for mobile pet grooming?<br>What kinds of customers buy apparel at tennis pro shops?<br>Which marketing channels work best for sports watches?<br>Develop two buyer personas for a luxury skincare product.<br>Generate a list of marketing keywords related to cruise line experiences.</i>";
            //this.addNewMessage(initialMessage,'Analyze Assistant',this.getNow(),'flex-row',false,false);
            //this.$emit('makeChatTrue');
            this.startConversation();
        }
    }
}
</script>